import { ComponentProps, createContext } from 'react';
import { Toast } from '../../../';

type ShowToast = Omit<ComponentProps<typeof Toast>, 'toastId'>;

type ShowToastContextType = {
  showToast: (showToast: ShowToast) => void;
};
export const ShowToastContext = createContext<ShowToastContextType>({
  showToast: () => {},
});

type CloseToastContextType = {
  closeToast: (removeToastId: string) => void;
};
export const CloseToastContext = createContext<CloseToastContextType>({
  closeToast: () => {},
});
